import styled from 'styled-components'

import { FONT_WEIGHT } from '../../../../../styles/theme'
// ============================================================================
// CARD ACTIONS
// Inline CTA button groups rendered inside the node card body.
// Each group has a label (e.g. "ADD SUB-IDEA") and a row of buttons.
// ============================================================================

const ACTIONS_CONFIG = {
  labelSize: '10px',
  labelWeight: 600,
  labelLetterSpacing: '0.5px',
  buttonFontSize: '12px',
  buttonPadding: '6px 14px',
  buttonRadius: '6px',
  gap: 8,
  groupGap: 12,
} as const

export const ActionsContainer = styled.div`
  display: flex;
  gap: ${ACTIONS_CONFIG.groupGap}px;
  padding: 6px 12px 12px;
  border-top: 1px solid var(--color-node-header-border);
`

export const ActionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`

export const GroupLabel = styled.span`
  font-size: ${ACTIONS_CONFIG.labelSize};
  font-weight: ${ACTIONS_CONFIG.labelWeight};
  text-transform: uppercase;
  letter-spacing: ${ACTIONS_CONFIG.labelLetterSpacing};
  color: var(--color-text-muted);
  padding-left: 2px;
`

export const ButtonRow = styled.div`
  display: flex;
`

export const ActionButton = styled.button<{
  $accentColor: string
  $variant: 'filled' | 'outline'
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  flex: 1;
  padding: ${ACTIONS_CONFIG.buttonPadding};
  border-radius: 0;
  font-size: ${ACTIONS_CONFIG.buttonFontSize};
  font-weight: ${FONT_WEIGHT.semibold};
  font-family: inherit;
  cursor: pointer;
  transition:
    background 0.15s,
    border-color 0.15s,
    opacity 0.15s;
  white-space: nowrap;

  background: ${(p) => (p.$variant === 'filled' ? p.$accentColor : 'transparent')};
  color: ${(p) => (p.$variant === 'filled' ? '#fff' : p.$accentColor)};
  border: 1.5px solid ${(p) => p.$accentColor};
  border-left: none;

  &:first-child {
    border-left: 1.5px solid ${(p) => p.$accentColor};
    border-radius: ${ACTIONS_CONFIG.buttonRadius} 0 0 ${ACTIONS_CONFIG.buttonRadius};
  }

  &:last-child {
    border-radius: 0 ${ACTIONS_CONFIG.buttonRadius} ${ACTIONS_CONFIG.buttonRadius} 0;
  }

  &:only-child {
    border-left: 1.5px solid ${(p) => p.$accentColor};
    border-radius: ${ACTIONS_CONFIG.buttonRadius};
  }

  /* Subtle divider between segments */
  & + & {
    border-left: 1px solid rgba(255, 255, 255, 0.3);
  }

  &:hover:not(:disabled) {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`

export const DropdownItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 2px 0;
`

export const DropdownItemTitle = styled.span`
  font-size: 13px;
  font-weight: ${FONT_WEIGHT.semibold};
  color: var(--color-text-primary);
`

export const DropdownItemSubtitle = styled.span`
  font-size: 11px;
  color: var(--color-text-tertiary);
`
